import { QueryClientProvider } from '@tanstack/react-query'
import { createRouter, RouterProvider } from '@tanstack/react-router'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { subscribeToStorageSync } from '@/auth/store'
import { NotFound } from '@/components/not-found'
import { RouteErrorBoundary } from '@/components/route-error'
import { RoutePending } from '@/components/route-pending'
import { Toaster } from '@/components/ui/sonner'
import { queryClient } from '@/lib/query-client'
import { startShootMode } from '@/lib/shoot-mode'

import { routeTree } from './routeTree.gen'

import '@/styles/index.css'

const router = createRouter({
  routeTree,
  context: { queryClient },
  defaultPreload: 'intent',
  defaultPreloadStaleTime: 0,
  defaultNotFoundComponent: NotFound,
  defaultErrorComponent: RouteErrorBoundary,
  defaultPendingComponent: RoutePending,
  defaultPendingMs: 200,
  scrollRestoration: true,
})

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

// Une déconnexion dans un autre onglet doit se refléter ici immédiatement.
subscribeToStorageSync()

const rootElement = document.getElementById('root')
if (!rootElement) throw new Error('Élément racine #root introuvable')

// Lot 38 : le mode tournage fige l'horloge avant tout rendu, et attend les
// polices pour que chaque prise rende la même chose.
const shoot = startShootMode()
const ready = shoot ? document.fonts.ready.then(() => undefined) : Promise.resolve()

void ready.then(() => {
  createRoot(rootElement).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
        <Toaster />
      </QueryClientProvider>
    </StrictMode>,
  )
})
